import React from 'react'
import { TrialPage } from './pages/TrialPage'
import { DemoPage } from './pages/DemoPage'

const App = () => {
  const path = window.location.pathname
  if (path.includes('/demo')) return <DemoPage />
  return <TrialPage />
}

export default App
